<template>
  <div class="sc-outer">
    <div class="login-outer">
      <div class="login-main">
        <div class="left"></div>
        <div class="right">
          <div class="header-title">
            <img class="logo" src="~@/assets/logo-1.png" width="50" alt="" />
            <span style="padding-left: 10px;" >智养通</span>
          </div>
          <router-view />
          <div class="top-logo">
            <img src="@/assets/ths-logo.png" width="200" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted } from 'vue';

export default defineComponent({
  name: 'UserLayout',
  setup() {
    onMounted(() => {
      document.body.classList.add('userLayout');
    });
    onUnmounted(() => {
      document.body.classList.remove('userLayout');
    });

    return {};
  },
});
</script>


<style lang="less" scoped>
.sc-outer {
  width: 100vw;
  height: 100vh;
  overflow: auto;
}

.login-outer {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: clamp(1200px, 100vw, 100vw);
  height: clamp(800px, 100vh, 100vh);
  padding: 0 96px;
  background: url('@/assets/bg-1.png');
  // background: url('@/assets/back-login.jpg') no-repeat;
  background-position: center;
  background-size: cover;
  // background-origin: 78% center;

  .login-main {
    position: absolute;
    top: 50%;
    // right: 22%;
    left: 50%;
    // width: 350px;
    // height: 400px;
    width: 75%;
    height: 700px;
    background: #ffffff;
    border-radius: 10px;
    // box-shadow: 0px 4px 9px 1px rgba(226, 226, 226, 0.6);
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: space-between;

    .left {
      width: 65%;
      height: 100%;
      background: url('@/assets/bg-5.png') no-repeat;
      // background: url('@/assets/bg-4.png') no-repeat;
      // background: url('@/assets/back-login.jpg') no-repeat;
      background-position: center;
      background-size: cover;
      border-radius: 10px 0 0px 10px;
    }

    .right {
      width: 35%;
      height: 100%;
      padding: 30px 50px 50px 50px;
      box-sizing: border-box;

      .top-logo {
        text-align: center;
      }

      .header-title {
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 48px;
        color: #1C1C1C;
        text-align: center;
        margin-top: 80px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .t-1 {
    color: #e7f0f6;
    font-weight: 500;
    font-size: 64px;
    font-family: Source Han Sans CN;
    line-height: 90px;
  }

  .copy {
    position: absolute;
    bottom: 0;
    left: 0;
    color: #ffffff;
    font-weight: 400;
    font-size: 14px;
    font-family: Source Han Sans CN;
    // transform: translate(-50%, 0);
    width: 100%;
    // height: 45px;
    height: 30px;
    background: #33333399;
    text-align: center;
    padding-top: 5px;
    box-sizing: border-box;

  }

  .header-text {
    position: absolute;
    top: 0;
    left: 0;
    height: 60px;
    width: 100%;
    background: #FFFFFF;
    line-height: 60px;
    padding: 0 30px;
    box-sizing: border-box;
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 28px;
    color: #378ACB;
    // color: #0081CC;
    display: flex;
    align-items: center;

    .logo {
      height: 44px;
      margin-right: 16px;
      vertical-align: top;
      border-style: none;
    }
  }
}

@media screen and (max-width: 1600px) {
  .login-outer {
    padding: 0 30px;

    .t-1 {
      font-size: 45px;
    }
  }
}
</style>
